import React from "react";

import cx from "clsx";

interface ToggleProps {
  className?: string;
  label: string;
  active?: boolean;
  onToggle?(): void;
}

const Toggle = ({ className, label, active, onToggle = () => {} }: ToggleProps) => {
  const classes = cx("custom-control", "custom-switch", className);

  return (
    <div className={classes} onClick={() => onToggle()}>
      <input type="checkbox" className="custom-control-input" checked={active} onChange={() => {}} />
      <label className="custom-control-label">{label}</label>
    </div>
  );
};

export default Toggle;
